import { Component, Input, OnInit} from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { GroupGiftCardTransactionsViewModel} from "../../../models/recon-report-view-model";
import { GenericReportViewModel, TransactionAmountModel, TransactionAmount, merchantDetails } from '../../../models/generic-report-view-model';
import { GenericTransactionsViewModel } from '../../../models/generic-transactions-view-model';
import { ReportService } from '../../../services/report.service';
import { GroupGenericTransactionsViewModel } from '../../../models/group-generic-transactions-view-model';

@Component({
  selector: 'exception-card-report-component',
  templateUrl: './exception-card-report.component.html'
})

export class ExceptionCardReportComponent implements OnInit {

  groupedTerminals: GroupGiftCardTransactionsViewModel[] = [];
  transactionTypes: TransactionAmountModel[] = [];
  transactionAmount: TransactionAmount[] = [];
  transactionReport: GenericTransactionsViewModel[] = [];

  merchantNameLocation: string;
  raiseWarning!: boolean;

  hasValue: boolean = false;
  grandAmount: string;
  @Input() StartDate: string;
  @Input() EndDate: string;
  @Input() formatDate!: (date: string) => string;
  @Input() convertToDecimal: (amount?: number | null) => string;
  @Input() merchantDetails: merchantDetails = { merchantName: "", merchantNumber: "" };

  cardTypeTransactions: GroupGenericTransactionsViewModel[] = [];

  constructor(
    private loader: NgxUiLoaderService,
    private _reportService: ReportService,
    private datePipe: DatePipe) {
  }

  async ngOnInit() {
    this.loader.stop();
  }

  private resetState() {
    this.transactionReport = [];
    this.groupedTerminals = [];
    this.transactionAmount = [];
    this.hasValue = false;
    this.raiseWarning = false;
  }
  private handleEmptyState() {
    this.raiseWarning = true;
    this.loader.stop();
  }

  async GetReport(_modelReport: GenericReportViewModel) {
    debugger;
    this.resetState();
    this.transactionReport = await this._reportService.GetExceptionData(_modelReport);

    if (!this.transactionReport?.length) {
      this.handleEmptyState();
      return;
    }
    else {
      const groupTerminalMapping = new Map<string, {
                                    postTranId: number; pan: string;datetimeReq: string; tranType: string;
        totalsGroup: string; amountAvailable: number; terminalId: string; items: any[]
      }>();

      this.transactionReport.forEach(terminal => {
        if (!groupTerminalMapping.has(terminal.terminalId)) {
          groupTerminalMapping.set(terminal.terminalId, {
            terminalId: terminal.terminalId,
            datetimeReq: this.datePipe.transform(terminal.datetimeReq, 'yyyy-MM-dd hh:mm:ss'),
            pan: terminal.pan,
            postTranId: terminal.postTranId,
            totalsGroup: terminal.totalsGroup,
            tranType: terminal.tranType,
            amountAvailable: 0,
            items: []
          });
        }

        terminal.datetimeReq = this.formatDate(terminal.datetimeReq);;       
        const group = groupTerminalMapping.get(terminal.terminalId)!;    
        group.items.push(terminal);
        group.amountAvailable += terminal.amountAvailable;
        group.amountAvailable = parseFloat(group.amountAvailable.toFixed(2));

      });

      const groupMapper = new Map<string, Map<string, GroupGenericTransactionsViewModel>>();

      this.transactionReport.forEach(transaction => {
        const { terminalId, totalsGroup, amountAvailable } = transaction;

        if (!groupMapper.has(terminalId)) {
          groupMapper.set(terminalId, new Map<string, GroupGenericTransactionsViewModel>());
        }

        const totalsGroupsMap = groupMapper.get(terminalId)!;

        if (!totalsGroupsMap.has(totalsGroup)) {
          totalsGroupsMap.set(totalsGroup, {
            terminalId,
            totalsGroup,
            amountAvailable: 0,
            postTranId: transaction.postTranId,
            pan: transaction.pan,
            datetimeReq: transaction.datetimeReq,
            tranType: transaction.tranType,
            items: [],
          });
        }

        const group = totalsGroupsMap.get(totalsGroup)!;
        group.items.push(transaction);
        group.amountAvailable += amountAvailable;
        group.amountAvailable = parseFloat(group.amountAvailable.toFixed(2));
      });

      this.cardTypeTransactions = [];
      groupMapper.forEach(totalsGroupsMap => {
        totalsGroupsMap.forEach(group => {
          this.cardTypeTransactions.push(group);
        });
      });

      this.groupedTerminals = Array.from(groupTerminalMapping.values());
      var total = this.groupedTerminals.reduce((sum, group) => sum + group.amountAvailable, 0);
      this.grandAmount = total.toFixed(2).toString();

      if (this.transactionReport.length > 0) {
        this.merchantNameLocation = this.transactionReport[0].merchantNameLocation + " - " + this.transactionReport[0].cardAcceptorIdCode;
        this.hasValue = true;
        this.transactionTypes = this.getTerminalTransactionTypes();

        this.merchantDetails = {
          merchantName: this.transactionReport[0].merchantNameLocation + " - Exception switch only report",
          merchantNumber: this.transactionReport[0].cardAcceptorIdCode,
        }

        this.transactionAmount.push({
          tranType: "Grand Total",
          amount: parseFloat(this.grandAmount).toFixed(2)
        });
      }
      this.loader.stop();
    }
  }

  public getTerminalTransactionTypes(): TransactionAmountModel[] {

    const result: Record<string, TransactionAmountModel> = {};

    for (const grp of this.groupedTerminals) {
      const terminalTransactions = this.transactionReport
        .filter(t => t.terminalId === grp.terminalId);

      for (const transaction of terminalTransactions) {
        const tranTypeCode = transaction.tranType;

        if (!result[tranTypeCode]) {
          result[tranTypeCode] = {
            tranType: tranTypeCode,
            amount: 0
          };
        }
        result[tranTypeCode].amount += transaction.amountAvailable;
      }
    }
    return Object.values(result);
  }
}
